import axios from 'axios';

/**
 * PUT a file to a presigned storage URL, or throw.
 *
 * Every upload in admin is presign, PUT, then record the attachment and point
 * something at it. Two ways that went wrong, and why this exists:
 *
 * - An EMPTY file uploads happily. S3 stores 0 bytes, the attachment row is
 *   written, the listing points at it, and the page shows a broken image. Nine
 *   live listing covers were exactly that (Abacela among them), all uploaded
 *   within minutes on 2026-02-25. A cloud-synced file that was never downloaded
 *   (iCloud, Dropbox) reads as 0 bytes in the browser.
 * - `fetch` does not reject on a 403 or 500, so a refused PUT went on to record
 *   an attachment for a file that is not there. axios rejects on any non-2xx.
 *
 * Drop-in for `axios.put(url, file, options)`; Content-Type defaults to the
 * file's own type.
 */
export function assertUploadable(file) {
  if (!file) throw new Error('No file was chosen.');
  if (!file.size) {
    throw new Error(
      `"${file.name || 'This file'}" is empty (0 bytes), so it was not uploaded. `
      + 'If it lives in iCloud or Dropbox, download it to this computer first.',
    );
  }
}

export default async function putToStorage(url, file, options = {}) {
  assertUploadable(file);
  return axios.put(url, file, {
    ...options,
    headers: { 'Content-Type': file.type, ...(options.headers || {}) },
  });
}

/**
 * Wrap a file input's async change handler so a refused or failed upload says
 * why instead of failing silently. `after` resets the caller's spinner.
 */
export function withUploadAlert(handler, after) {
  return (event) => Promise.resolve(handler(event)).catch((err) => {
    alert(`Upload failed: ${err.message}`);
    if (after) after();
  });
}
